import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerDto, CustomerType } from 'src/app/models/trofaco/customerDto';
import { CustomerService } from 'src/app/modules/core/services/customer.service';
import { DuplicateNameConfirmModalComponent } from './duplicate-name-confirm-modal/duplicate-name-confirm-modal.component';

@Component({
    selector: 'app-customer-details',
    templateUrl: './customer-details.component.html'
})
export class CustomerDetailsComponent implements OnInit {

    @ViewChild(DuplicateNameConfirmModalComponent, { static: false }) confirmDuplicateName: DuplicateNameConfirmModalComponent;

    customer: CustomerDto;
    countries: [];
    customerType = CustomerType;
    customersName: string[];
    copyCustomerName: string;

    private hadLogo: boolean;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private customerService: CustomerService) {
    }

    async ngOnInit() {
        this.route.data.subscribe(value => {
            this.customer = value.customer;
            this.copyCustomerName = value.customer.name;
            this.countries = value.countries;
            this.hadLogo = !!this.customer.logo;
        });
        this.customersName = await this.customerService.getCustomersName();
    }

    async save(){
        if (!this.customer.name || !this.customer.country)
            return;

        let isDuplicateName = this.customersName.some((element) => {
            const customerName = element.trim().toLocaleLowerCase();
            const newCustomerName = this.customer.name.trim().toLocaleLowerCase();
            return customerName === newCustomerName;
        });

        if (!isDuplicateName || this.copyCustomerName == this.customer.name) 
            this.execute();
        else {

            if (this.customer.id) 
                this.confirmDuplicateName.editMode();
 
            let result = await this.confirmDuplicateName.showAwait();
            if (result) {
                this.execute();
            }
        }

    }

    async execute() {
        if(!this.customer.id)
            this.customer.id = await this.customerService.create(this.customer);
        else
            await this.customerService.update(this.customer);

        if (this.customer.file)
            await this.customerService.updateLogo(this.customer.file, this.customer.id);
        else if(!!this.customer.file == this.hadLogo)
            await this.customerService.removeLogo(this.customer.id);

        this.router.navigate(['/admin/customers']);
    }

    async removeLogo(){
        this.customer.file = null;
        this.hadLogo = false;
    }

}
